// extracted by mini-css-extract-plugin
export default {"container":"style_container__8vhAf","areaSelect":"style_areaSelect__wH9Wj","statusCheckbox":"style_statusCheckbox__OZIuW","optionCentered":"style_optionCentered__ByRXf"};